import React from "react";

import { CustomSalesCard } from "../../../../components/customSalesCard/index";
function CustomCardView(props) {
  let {
    data,
    fetchCsvData,
    id,
    isCsvActive,
    tileName,
    rechargeSalesCsvLoading,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    dashboardName,
    viewName,
  } = props;
  return (
    <div className="tab-content">
      <div id={`#rsd${id}`} className="tab-pane fade in active">
        <div className="tabcontbox ">
          <div className="row">
            <CustomSalesCard
              achieved={data.actualValue}
              target={data.planValue}
              lmtdQty={data.lmtdVal}
              percentAchieved={data.percentAchieved}
              csvDownload={
                isCsvActive === "Y" &&
                data.rechargeType === "RECHARGE SALES" &&
                tileName.toLowerCase().split(" ")[0] !== "primary"
                  ? fetchCsvData
                  : ""
              }
              csvName={data.rechargeType}
              image="Image4"
              gradient="3"
              loading={rechargeSalesCsvLoading}
              dashboardName={dashboardName}
              viewName={viewName}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default CustomCardView;
